import { render, staticRenderFns } from "./orderIncome.vue?vue&type=template&id=3ff90d72&scoped=true"
import script from "./orderIncome.vue?vue&type=script&lang=js"
export * from "./orderIncome.vue?vue&type=script&lang=js"
import style0 from "./orderIncome.vue?vue&type=style&index=0&id=3ff90d72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff90d72",
  null
  
)

export default component.exports